// Number inputs change their value on scroll while focused. Attach this ref
// so only the stepper buttons change the number.
export function blockWheelOnNumber(node) {
  if (!node || node.dataset.wheelBlocked === 'true') return;
  node.dataset.wheelBlocked = 'true';
  node.addEventListener('wheel', (event) => {
    event.preventDefault();
  }, { passive: false });
}
